export const Required = "This field is required";
export const patternEmail = "Please type a valid email";
export const patternMinLength = (value) => `This field should be minimum ${value} characters`